<template>
	<span class="description-text">
		<template v-for="(part, i) in formattedDescription">
			<component :key="i" v-if="part.component" :is="part.component" v-bind="part.props" />
			<span :key="i" v-html="getCleanHtml(part.text)" v-else />
		</template>
	</span>
</template>
<script>
import { sanitizeHtml } from '@/utils/helpers';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { userFavoritePlyServicesIds } from '@/store/modules/auth/getters.js';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service.js';
export default {
	name: 'IdeaFormattedDescription',
	props: { idea: { type: Object } },
	computed: {
		...mapGettersShorthand({ userFavoritePlyServicesIds }),
		formattedDescription() {
			return InspirationCenterService.formatContentWithServiceDetails(
				this.idea.description,
				this.idea.params,
				this.userFavoritePlyServicesIds
			);
		},
	},
	methods: {
		getCleanHtml(dirtyContent) {
			return sanitizeHtml(String(dirtyContent));
		},
	},
};
</script>

<style scoped lang="scss">
.description-text {
	font-size: 13px;
}
</style>
